"use strict";

/**
 * Show popunder Ad instead of source site when  trying to click "Back"
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var stopCookie = 'bbh_stop';
  /** If events were already initialized in previous `onPageLoad` */
  var initialized = false;

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** No stop cookie */ && !FlixUtils.hasCookie(stopCookie)
    /** Not for bots and crawlers */ && !FlixUtils.isCrawler()
    // Disable for Chrome temporarily
    && (!FlixUtils.isChrome() || Flix.ads.wild)
    /** Not on TNA organic */ && !(Flix.isTna() && Flix.ads.isOrganic())
    /** History API should be available */ && typeof window.history != 'undefined' && typeof window.history.pushState != 'undefined';
  }
  ;

  /**
   * Initialize events here instead of `init()` because we need FlixUtils
   * in `isEnabled()`that  might not be loaded during `init()` call
   */
  function onPageLoad() {
    if (initialized || !isEnabled()) {
      return;
    }
    initialized = true;
    var currentUrl = window.location.href;
    window.history.pushState('/exo1234.html', '_', '/exo1234.html');
    window.history.pushState(currentUrl, 'Flix', currentUrl);
    window.addEventListener('popstate', onBack);
  }
  ;

  /**
   * Main logic
   */
  function onBack() {
    if (document.URL.indexOf("exo1234.html") >= 0) {
      if (isEnabled()) {
        FlixUtils.setCookie(stopCookie, 1, 1);
        window.location.href = FlixPop.getPopUrl();
      } else {
        try {
          window.history.go(-2);
        } catch (z) {}
      }
    }
  }
  ;
})();